import { useSyncExternalStore } from 'react'

// Note: what the sync worker is doing, published so the UI can say so. Reconnecting after a shift's
// work offline can take a while, and with nothing on screen it looked as though the queue had been
// lost - the crew had no way to tell "working through 86 changes" from "everything is gone".

export interface SyncProgress {
  isSyncing: boolean
  /** Changes in the batch being sent. */
  total: number
  /** Changes the server has acknowledged so far. */
  done: number
}

let progress: SyncProgress = { isSyncing: false, total: 0, done: 0 }
const listeners = new Set<() => void>()

function publish(next: SyncProgress) {
  progress = next
  for (const listener of listeners) listener()
}

export function beginSync(total: number): void {
  publish({ isSyncing: true, total, done: 0 })
}

export function reportSynced(count: number): void {
  if (!progress.isSyncing) return
  publish({ ...progress, done: Math.min(progress.total, progress.done + count) })
}

export function endSync(): void {
  publish({ isSyncing: false, total: 0, done: 0 })
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export function useSyncProgress(): SyncProgress {
  return useSyncExternalStore(subscribe, () => progress, () => progress)
}
